import { hover } from 'pobble-components/dist/jss-mixins'

const styles = {
  button: {
    cursor: 'pointer',
    fontSize: '14px',
    textAlign: 'center',
    userSelect: 'none',
    border: '1px solid #dedede',
    borderRadius: '4px',
    background: 'none',
    width: '40px',
    height: '40px',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    outline: 'none',
    ...hover({
      borderColor: '#999',
      '& $icon': {
        color: '#333'
      }
    }),
    '&:active': {
      boxShadow: '0 0 2px 1px rgba(0, 0, 0, 0.1)'
    }
  },
  icon: {
    color: '#999',
    width: '20px',
    height: '20px'
  },
  disabled: {
    cursor: 'default',
    background: '#F9F9F9',
    borderColor: '#ECECEC',
    ...hover({
      borderColor: '#ECECEC',
      '& $icon': {
        color: '#999'
      }
    })
  }
}

export default styles
